import { render, staticRenderFns } from "@/components/Layout/Menu/Gestores/Acarreo/Editar_acarreo/Editar_acarreo.html?vue&type=template&id=bc73d512&scoped=true&"
import script from "@/components/Layout/Menu/Gestores/Acarreo/Editar_acarreo/Editar_acarreo.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Gestores/Acarreo/Editar_acarreo/Editar_acarreo.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Gestores/Acarreo/Editar_acarreo/Editar_acarreo.css?vue&type=style&index=0&id=bc73d512&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc73d512",
  null
  
)

export default component.exports